import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth.tsx";

export function TenantPickerPage() {
  const { me } = useAuth();
  if (!me) return null;
  return (
    <div className="auth-shell">
      <div className="auth-card" style={{ width: "min(560px, 100%)" }}>
        <p className="eyebrow">Escolha</p>
        <h1 className="crown">Em qual operação você quer entrar?</h1>
        <p className="sub">Você tem acesso a {me.memberships.length} {me.memberships.length === 1 ? "tenant" : "tenants"}.</p>
        <div style={{ display: "grid", gap: ".6rem" }}>
          {me.memberships.map((m) => (
            <Link
              key={m.slug}
              to={`/t/${m.slug}/strategic`}
              className="list-row"
              style={{
                background: "var(--surface)",
                border: "1px solid var(--border)",
                borderRadius: "var(--r-sm)",
                padding: "1rem 1.2rem",
                textDecoration: "none",
              }}
            >
              <span>
                <strong>{m.name}</strong>
                <span className="mono" style={{ marginLeft: ".7rem", opacity: .55, fontSize: ".78rem" }}>{m.slug}</span>
              </span>
              <span className="pill">{m.role}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
